import { powerbiVariance } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  check(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(powerbiVariance.powerbiVarianceBase, { params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
